import script from "./LoggedMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoggedMenu.vue?vue&type=script&setup=true&lang=ts"

import "./LoggedMenu.vue?vue&type=style&index=0&id=7533f454&scope=true&lang=css"

const __exports__ = script;

export default __exports__